angular.module('impactx.approval').directive('appApprovalItem', function() {
    return {
        scope: {
            item: '=',
            selectedItems: '=',
            trns: '=',
            hasRightToApprove: "=",
            hasRightToDeny: "=",
            hasRightToDelegate: "=",
            hasRightToDelegateBack: "=",
            hasRightToStop: "=",
            showNet: "=",
            showGross: "=",
            showComments: "=",
            showControl: "=",
            selectedSupplier: "=",
            showCatalogNet: "=",
            recallDelegate: '&',
            recallEscalate: '&',
            changeAatFunc: '&',
            dialogData: '=',
            requireAat: "=",
            requireCtrl: "&",
            supplCtrlSelected: '=',
            showDates: '='
        },
        restrict: 'E',
        controller: 'ApprovalItemCtrl',
        controllerAs: 'approvalItemCtrl',
        templateUrl: 'modules/approval/templates/approvalitem.tmpl.html',
        transclude: true
    }
});